/* global AFRAME */

import { isMobile } from "react-device-detect";

let startX = 0;
let startY = 0;

const isClick = (start, end) => {
  return Math.abs(start.x - end.x) < 5 && Math.abs(start.y - end.y) < 5;
};

AFRAME.registerComponent("zoom", {
  schema: {
    initialFOV: { default: 50 },
    targetFOV: { default: 100 },
  },

  init: function () {
    this.el.addEventListener("mousedown", (event) => {
      startX = event.clientX;
      startY = event.clientY;
    });

    this.el.addEventListener("touchstart", (event) => {
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    });

    const endHandler = (event) => {
      let endX, endY;

      if (event.changedTouches) {
        endX = event.changedTouches[0].clientX;
        endY = event.changedTouches[0].clientY;
      } else {
        endX = event.clientX;
        endY = event.clientY;
      }

      if (!isClick({ x: startX, y: startY }, { x: endX, y: endY })) return;

      let camera_element = this.el.querySelector("[camera]");
      if (!camera_element) return;

      let currentFOV = camera_element.getAttribute("camera").fov;
      let targetFOV =
        currentFOV == this.data.initialFOV
          ? this.data.targetFOV
          : this.data.initialFOV;
      let duration = currentFOV == this.data.initialFOV ? "350" : "200";

      let uniqueZoomID = "zoomAnimation";

      camera_element.setAttribute("animation__" + uniqueZoomID, {
        property: "camera.fov",
        to: targetFOV,
        dur: duration,
        easing: "easeInOutQuad",
      });

      camera_element.addEventListener("animationcomplete", (event) => {
        if (event.detail.name === "animation__" + uniqueZoomID) {
          // Aquí puedes poner cualquier código que necesites ejecutar cuando se complete la animación
        }
      });
    };

    this.el.addEventListener("mouseup", endHandler);
    this.el.addEventListener("touchend", endHandler);
  },
});

export function applyZoom(element) {
  const initialFOV = isMobile ? 110 : 80;
  const targetFOV = isMobile ? 80 : 50;

  if (element) {
    element.setAttribute("zoom", { initialFOV, targetFOV });
  }
}
